export const thresholdValue = 1e-6;
export const arcThresholdValue = 1e-3;
export const thresholdAngle = 1e-5; // 弧度制，1000米远时会产生1厘米误差
export const thresholdValueMagnitude = 6; // 阈值数量级

export const pixelRatio2d = 1000;
export const pixelRatio3d = pixelRatio2d;

export const scale2dTo3d = 4;

export const wallAdsorbDistance = 200;
export const boundingBoxAdsorbDistance = 100;

export const OVERLAPLENGTH = 1;

export const effectiveDistance = 0.01;

export const orthogonalMin = -1000;
export const orthogonalMax = 1000;
